<template>
  <div>
    <DxDropDownButton
      :items="getItems"
      :keyExpr="'ScreenLayoutApplicationFeatureCode'"
      :displayExpr="'ReportDisplayName'"
      :drop-down-options="{ width: 200 }"
      class="gc-dropdown-icon-button"
      :icon="'message'"
      styling-mode="text"
      :show-arrow-icon="false"
      :onItemClick="onItemClick"
    />
    <!-- v-if="getItems.length > 1" -->
    <!-- <DxButton
      class="invoice-print-btn"
      icon="message"
      @click="onItemClick({ itemData: getItems[0] })"
      v-else
    /> -->

    <GcPopup
      :popup-visible="popupVisible"
      :popup-title="'Warning'"
      :back-button-function="popupBackButtonClick"
      :popupHeight="250"
      v-if="popupVisible"
    >
      <span v-html="errorMsg"></span> <br />

      <p>
        <span>
          Please <a @click="onClickToAddContact">click here</a> to configure
          email settings.
        </span>
      </p>
    </GcPopup>

    <GcPopupInteractiveEmail
      :visible.sync="getVisibleEmailPopup"
      :showLoading="showLoading"
      :emailModel="emailModel"
      :invoice-number="
        getReferenceField || data.data[data.column.ReferenceNoField]
      "
      ref="gc-popup-interactive-email"
      @send-email-success="sendEmailSuccess"
      v-if="getVisibleEmailPopup"
    />
  </div>
</template>
<script>
import { InteractiveEmailService } from "../_services/api/customers/interactive-email.service";
import GcPopupInteractiveEmail from "../popups/data-grid/gc-popup-interactive-email.vue";
export default {
  components: {
    GcPopupInteractiveEmail,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    dataField: {
      type: String,
      default: "Code",
    },
    refresh: {
      type: Function,
      default: () => {},
    },
    gridColumns: {
      type: [Object, Array],
      default: () => {},
    },
    baseView: {
      type: Object,
    },
  },
  data() {
    return {
      printReports: undefined,
      validationSummaryVisible: false,
      validationItems: [],
      popupVisible: false,
      errorMsg: undefined,
      errorData: undefined,
      visibleEmailPopup: false,
      emailModel: undefined,
    };
  },

  computed: {
    getItems() {
      if (this.data.column.BackgroundEmail)
        if (this.data.column.menuItems)
          if (this.data.column.menuItems.makeDisabled)
            return this.data.column.menuItems.makeDisabled(this.data);
          else return this.data.column.BackgroundEmail;
        else return this.data.column.BackgroundEmail;
      else return [];
    },

    /*
     * Computed property to get and set the visibility of the popup
     */
    getVisibleEmailPopup: {
      get() {
        return this.visibleEmailPopup;
      },
      set(value) {
        this.visibleEmailPopup = value;
      },
    },

    getReferenceField() {
      const itemData = this.emailModel.itemData;

      if (itemData.ScreenName === "Batch Payment List") {
        let referenceField = this.data.column.ReferenceNoField;
        return this.data.data[referenceField];
      } else {
        var referenceNoField = undefined;
        if (this.data.column.ReferenceNoField)
          referenceNoField = this.data.column.ReferenceNoField;
        else if (this.data.column.ReferenceNoFields) {
          this.data.column.ReferenceNoFields.forEach((element) => {
            if (element.ReportDisplayName == itemData.ReportDisplayName) {
              referenceNoField = element.ReferenceNoField;
            }
          });
        }
        // ReferenceNo should be a String
        return "" + this.data.data[referenceNoField];
      }
    },
  },
  methods: {
    onClickToAddContact() {
      this.popupBackButtonClick();

      let baseUrl = process.env.VUE_APP_BASE_URL;
      let url = "";

      if (this.errorData.ContactType == "Customer") {
        if (baseUrl === "/")
          url = `${baseUrl}customer-contact/${this.errorData.PartnerCode}`;
        else url = `/customer-contact/${this.errorData.PartnerCode}`;
      } else if (this.errorData.ContactType == "Supplier") {
        if (baseUrl === "/")
          url = `${baseUrl}supplier-contact/${this.errorData.PartnerCode}`;
        else url = `/supplier-contact/${this.errorData.PartnerCode}`;
      }

      var route = this.$router.resolve({ path: url });
      window.open(route.href, "_blank");
    },
    popupBackButtonClick() {
      this.popupVisible = false;
    },

    async sendEmailSuccess(payloadHelper) {
      let payload = {};
      const itemData = this.emailModel.itemData;

      if (itemData.ScreenName === "Batch Payment List") {
        payload = {
          ReportName: itemData.ReportDisplayName,
          ScreenName: itemData.ScreenName,
          TransactionCode: "RunId",
          ReferenceNo: this.getReferenceField,
        };
      } else {
        // ReferenceNo should be a String
        let referenceNo = this.getReferenceField;

        payload = {
          ReportName: itemData.ReportDisplayName,
          ScreenName: itemData.ScreenName,
          TransactionCode: itemData.TransactionCode,
          ReferenceNo: referenceNo,
        };
      }

      payload = { ...payload, ...payloadHelper };
      this.showLoading(true);
      try {
        const response =
          await InteractiveEmailService.SaveInteractiveEmailModal(payload);

        if (response) {
          if (itemData.ScreenLayoutApplicationFeatureCode === "ReportCofA") {
            this.$notify(
              `Certificate of Analysis request submitted successfully.`,
              "success",
            );
          } else {
            this.$notify(
              `${itemData.ReportDisplayName} email notification queued successfully`,
              "success",
            );
          }
        }
        this.refresh();
        this.showLoading(false);
        this.visibleEmailPopup = false;
        document.activeElement.blur();
      } catch (error) {
        this.showLoading(false);
        this.$store.dispatch("ui/setServerError", {
          error: error,
          title: "Failed",
        });
      }
    },
    async onItemClick(data) {
      document.activeElement.blur();
      this.showLoading(true);

      this.emailModel = { itemData: data.itemData };
      try {
        const response = await InteractiveEmailService.getInteractiveEmailModal(
          data.itemData.ScreenName,
          data.itemData.ReportDisplayName,
          data.itemData.TransactionCode,
          this.getReferenceField ||
            this.data.data[this.data.column.ReferenceNoField],
        );
        if (response && response.data) {
          this.emailModel = { ...response.data, itemData: data.itemData };
        } else {
          this.emailModel = { itemData: data.itemData };
        }
      } catch (error) {
        this.$store.dispatch("ui/setServerError", {
          error: error,
          title: "Failed",
        });
      } finally {
        this.visibleEmailPopup = true;
        this.showLoading(false);
      }
    },
  },
};
</script>

<style lang="scss"></style>
